import { render, staticRenderFns } from "./cdStockInfo.vue?vue&type=template&id=0b985c2d&scoped=true"
import script from "./cdStockInfo.vue?vue&type=script&lang=js"
export * from "./cdStockInfo.vue?vue&type=script&lang=js"
import style0 from "./cdStockInfo.vue?vue&type=style&index=0&id=0b985c2d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b985c2d",
  null
  
)

export default component.exports